/**
 * Copy provided value to the clipboard (ctrl + c)
 *
 * @param {string} text - value to copy
 */
export function copyToClipboard(text: string) {
  return navigator.clipboard.writeText(text).catch(() => {
    // we might not have navigator (unsecure domain) or writeText permission
    // fallback to execCommand
    return new Promise((resolve) => {
      // create text field with value, select, copy and remove it
      const textField = document.createElement('textarea');
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
      // finish promise
      return resolve(true);
    });
  });
}
